import { unlockFileConstants } from '../constants';

const initialState: {
  unlockStatusMap: {
    [partId: string]: 'REQUESTING' | 'UNLOCKED' | 'LOCKED' | 'ERROR';
  };
  error?: string;
} = {
  unlockStatusMap: {},
};

export const unlockFile = (
  state = initialState,
  action: {
    type: string;
    payload: {
      partId?: string;
      unlockSuccess?: boolean;
      error?: string;
    };
  },
) => {
  const { partId, unlockSuccess, error } = action.payload || {};
  switch (action.type) {
    case unlockFileConstants.UNLOCK_REQUEST:
      return {
        ...state,
        unlockStatusMap: {
          ...state.unlockStatusMap,
          [partId as string]: 'REQUESTING',
        },
      };
    case unlockFileConstants.UNLOCK_SUCCESS:
      return {
        ...state,
        unlockStatusMap: {
          ...state.unlockStatusMap,
          [partId as string]: unlockSuccess ? 'UNLOCKED' : 'LOCKED',
        },
      };
    case unlockFileConstants.UNLOCK_ERROR:
      return {
        ...state,
        unlockStatusMap: {
          ...state.unlockStatusMap,
          [partId as string]: 'ERROR',
        },
        error,
      };
    case unlockFileConstants.CLEAR:
      return initialState;
    default:
      return state;
  }
};
